import { PaginationProps } from '../types';
import { getCountPages } from '../utils';
import { threeDotsElement } from './constants';
import {
  DoubleArrowIcon,
  DoubleArrowIconRotated,
  LeftArrowIcon,
  LeftArrowIconRotated,
  PageItem,
  PageNumbersContainer,
} from './styled';
import { getPagesToShow } from './utils';

const PageNumbers = ({ currentPage, entriesPerPage, totalEntries, onPageChanged }: PaginationProps): JSX.Element => {
  const showedCurrentPage = currentPage + 1;
  const countPages = getCountPages(totalEntries, entriesPerPage);
  const onPageNumberClick = (pageNumber: number): void => {
    if (pageNumber === threeDotsElement) return;

    onPageChanged(pageNumber - 1);
  };

  const firstPage = showedCurrentPage === 1;
  const lastPage = showedCurrentPage === countPages;
  const goToFirstPage = (): void => {
    if (firstPage) return;

    onPageChanged(0);
  };

  const goToPreviousPage = (): void => {
    if (firstPage) return;

    onPageChanged(currentPage - 1);
  };

  const goToLastPage = (): void => {
    if (lastPage) return;

    onPageChanged(countPages - 1);
  };

  const goToNextPage = (): void => {
    if (lastPage) return;

    onPageChanged(currentPage + 1);
  };

  const pagesToShow = getPagesToShow(showedCurrentPage, countPages, 2);

  return (
    <PageNumbersContainer data-testid="pageNumbersContainer">
      <PageItem
        data-testid={firstPage ? 'goToFirstPageDisabled' : 'goToFirstPage'}
        key="page_first"
        $clickableElement={!firstPage}
        onClick={goToFirstPage}
      >
        <DoubleArrowIcon $clickableElement={!firstPage} />
      </PageItem>
      <PageItem
        data-testid={firstPage ? 'goToPreviousPageDisabled' : 'goToPreviousPage'}
        key="page_previous"
        $clickableElement={!firstPage}
        onClick={goToPreviousPage}
      >
        <LeftArrowIcon $clickableElement={!firstPage} />
      </PageItem>
      {pagesToShow.map((page, index) => (
        <PageItem
          onClick={(): void => onPageNumberClick(page)}
          $currentPage={page === showedCurrentPage}
          $clickableElement={page !== threeDotsElement}
          key={`page_${index}`}
          className={page === showedCurrentPage ? 'activePage' : ''}
          data-testid={page === threeDotsElement ? 'pageDivider' : `page_${page}`}
        >
          {page === threeDotsElement ? '...' : page}
        </PageItem>
      ))}
      <PageItem
        data-testid={lastPage ? 'goToNextPageDisabled' : 'goToNextPage'}
        key="page_next"
        $clickableElement={!lastPage}
        onClick={goToNextPage}
      >
        <LeftArrowIconRotated $clickableElement={!lastPage} />
      </PageItem>
      <PageItem
        data-testid={lastPage ? 'goToLastPageDisabled' : 'goToLastPage'}
        key="page_last"
        $clickableElement={!lastPage}
        onClick={goToLastPage}
      >
        <DoubleArrowIconRotated $clickableElement={!lastPage} />
      </PageItem>
    </PageNumbersContainer>
  );
};

export default PageNumbers;
